import axios from './axiosConfig'

interface SupplierData {
 name: string
 phone: string
 notes?: string
 opening_balance?: number
}

export const suppliersAPI = {
 getAll: async (params?: any) => {
 const response = await axios.get('/suppliers', {
 params: { balance_detail: 1, ...(params || {}) },
 })
 return response.data
 },

 getById: async (id: number) => {
 const response = await axios.get(`/suppliers/${id}`)
 return response.data
 },

 create: async (data: SupplierData) => {
 const response = await axios.post('/suppliers', data)
 return response.data
 },

 update: async (id: number, data: SupplierData) => {
 const response = await axios.put(`/suppliers/${id}`, data)
 return response.data
 },

 delete: async (id: number) => {
 const response = await axios.delete(`/suppliers/${id}`)
 return response.data
 },

 getReport: async (id: number, params?: any) => {
 const response = await axios.get(`/suppliers/${id}/report`, { params })
 return response.data
 },
}
